import {
  formatErrorWithRequestId,
  getRequestTransportErrorMessage,
  getSafeServerErrorMessage,
  readApiErrorEnvelope,
} from '#/utils/requestError';

export function getSalesOrderApiErrorMessage(error, fallback = '操作失敗') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'SALES_ORDER_SNAPSHOT_UNAVAILABLE') {
    const envelope = readApiErrorEnvelope(error);
    const message = envelope?.message || '銷貨單資料處理失敗';
    return formatErrorWithRequestId(message, envelope?.requestId);
  }

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'RESOURCE_NOT_FOUND' || code === 'SALES_ORDER_NOT_FOUND') {
    return data?.message || '找不到銷貨單資料';
  }

  const serverMessage = getSafeServerErrorMessage(error, fallback);
  if (serverMessage) {
    return serverMessage;
  }

  if (data?.message) {
    return data.message;
  }

  if (code) {
    return `${fallback}（${code}）`;
  }

  return fallback;
}

export function isSalesOrderVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}
